export default __webpack_public_path__ + "static/media/bh6.484902ac.webp";